<h3 class="type">{{ data.type }}</h3>
<h2 class="title">{{ data.title }}</h2>
<div class="message">{{ data.message }}</div>
<div class="messageDetail">{{ data.messageDetail }}</div>